<div class="fixed top-5 right-4 z-[99999] flex flex-col items-end gap-3 pointer-events-none max-w-sm sm:max-w-md w-full px-4 sm:px-0">
  <div *ngFor="let alert of notificationService.message; trackBy: trackById"
       (mouseenter)="onMouseEnter(alert)"
       (mouseleave)="onMouseLeave(alert)"
       class="toast-item relative w-full bg-white/95 backdrop-blur-md rounded-xl shadow-xl shadow-slate-900/10 border border-slate-100 overflow-hidden pointer-events-auto transform transition-all duration-300 ease-out border-l-4"
       [ngClass]="{
         'translate-x-0 opacity-100 scale-100': alert.visible,
         'translate-x-12 opacity-0 scale-95': !alert.visible,
         'border-l-emerald-500': alert.type === 'success',
         'border-l-amber-500': alert.type === 'warning',
         'border-l-rose-500': alert.type === 'danger',
         'border-l-blue-500': alert.type === 'info'
       }">

    <!-- Inner content -->
    <div class="p-4 pr-3 flex items-start gap-3.5">
      <!-- Icon badge -->
      <div class="flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center transition-transform duration-200"
           [ngClass]="{
             'bg-emerald-50 text-emerald-600 ring-1 ring-emerald-500/20': alert.type === 'success',
             'bg-amber-50 text-amber-600 ring-1 ring-amber-500/20': alert.type === 'warning',
             'bg-rose-50 text-rose-600 ring-1 ring-rose-500/20': alert.type === 'danger',
             'bg-blue-50 text-blue-600 ring-1 ring-blue-500/20': alert.type === 'info'
           }">

        <!-- Success Icon -->
        @if (alert.type === 'success') {
          <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        }

        <!-- Warning Icon -->
        @if (alert.type === 'warning') {
          <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
        }

        <!-- Danger / Error Icon -->
        @if (alert.type === 'danger') {
          <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
        }

        <!-- Info Icon -->
        @if (alert.type === 'info') {
          <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
        }
      </div>

      <!-- Text Details -->
      <div class="flex-1 min-w-0 pt-0.5">
        <h4 class="text-sm font-semibold text-slate-800 tracking-tight leading-none mb-1">
          {{ alert.title || getDefaultTitle(alert.type) }}
        </h4>
        <p class="text-xs text-slate-600 leading-relaxed break-words">
          {{ alert.msg }}
        </p>
      </div>

      <!-- Close Button -->
      <div class="flex-shrink-0 -mt-1">
        <button type="button"
                (click)="handleOnClose(alert)"
                class="p-1 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 active:bg-slate-200 transition-colors duration-150 focus:outline-none"
                aria-label="Dismiss notification">
          <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

